import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import React from 'react';
import { bool, func, string } from 'prop-types';
import { ArrowBack, CloseCircleFilled } from '@magalu/stereo-ui-icons';
import HiddenLabel from '../../HiddenLabel';
import { ContainerInput, Input, SearchIcon } from './input-container.styles';

const InputContainer = _ref => {
  let {
    desktopMode,
    handleClear,
    handleClose,
    handleOpen,
    handleSubmit,
    handleType,
    inputChange,
    handleClickEvent,
    keypressHandler,
    term,
    disableClear
  } = _ref,
      props = _objectWithoutPropertiesLoose(_ref, ["desktopMode", "handleClear", "handleClose", "handleOpen", "handleSubmit", "handleType", "inputChange", "handleClickEvent", "keypressHandler", "term", "disableClear"]);

  return /*#__PURE__*/React.createElement(ContainerInput, {
    "data-testid": "input-container",
    inputChange: inputChange,
    desktopMode: desktopMode
  }, !desktopMode && inputChange && /*#__PURE__*/React.createElement(ArrowBack, {
    color: "#818181",
    "data-testid": "arrow-back",
    onClick: handleClose
  }), /*#__PURE__*/React.createElement("form", {
    "data-testid": "form-search",
    onSubmit: e => handleSubmit(e, 'submit'),
    autoComplete: "off"
  }, /*#__PURE__*/React.createElement(HiddenLabel, {
    text: "Procure no magalu",
    htmlFor: "input-search"
  }), /*#__PURE__*/React.createElement(Input, _extends({}, props, {
    onChange: e => handleType(e),
    onClick: handleOpen,
    value: term,
    id: "input-search",
    type: "search",
    isChanging: inputChange,
    desktopMode: desktopMode,
    onKeyDown: keypressHandler,
    "data-testid": "input-search",
    accessKey: "s"
  }))), (!disableClear || !desktopMode && inputChange && term !== '') && /*#__PURE__*/React.createElement(CloseCircleFilled, {
    "data-testid": "close-circle",
    color: "#818181",
    onClick: handleClear,
    width: 17,
    height: 17,
    margin: !disableClear ? '0 16px' : 'unset',
    marginRight: 2,
    marginBottom: '1px'
  }), /*#__PURE__*/React.createElement(SearchIcon, {
    "aria-label": "Buscar produto",
    "data-testid": "search-submit",
    desktopMode: desktopMode,
    onClick: e => {
      handleSubmit(e, 'icon');
      handleClickEvent();
    },
    role: "button",
    tabIndex: "0"
  }));
};

process.env.NODE_ENV !== "production" ? InputContainer.propTypes = {
  desktopMode: bool,
  handleClear: func.isRequired,
  handleClose: func.isRequired,
  handleOpen: func.isRequired,
  handleSubmit: func.isRequired,
  handleClickEvent: func.isRequired,
  handleType: func.isRequired,
  inputChange: bool,
  keypressHandler: func.isRequired,
  disableClear: bool,
  term: string
} : void 0;
InputContainer.defaultProps = {
  desktopMode: false,
  inputChange: false,
  disableClear: true,
  term: ''
};
export default InputContainer;